import React, { useState, useRef, useEffect } from 'react';

const CustomDropdown = ({ id, name, value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const options = [
    { value: 0, label: 'Select Ceremony' },
    ...Array.from({ length: 20 }, (_, i) => ({ value: i + 1, label: String(i + 1) }))
  ];

  const handleSelect = (selectedValue) => {
    onChange({ target: { id, name, value: selectedValue } });
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className="dropdown-container-ceremony">
      <div
        className="dropdown-header-ceremony"
        tabIndex="0"
        onClick={() => setIsOpen(!isOpen)}
        onKeyDown={(e) => e.key === 'Enter' && setIsOpen(!isOpen)}
      >
        <span>{value || 'Select Ceremony'}</span>
        <svg
          className={`dropdown-icon ${isOpen ? 'rotate-180' : ''}`}
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M6 9l6 6 6-6"></path>
        </svg>
      </div>
      {isOpen && (
        <ul className="dropdown-list-ceremony ">
          {options.map((option) => (
            <li
              key={option.value}
              className={`dropdown-item-ceremony ${value === option.value ? 'selected' : ''}`}
              onClick={() => handleSelect(option.value)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;
